
    import Vue from 'vue';
    import { 
      UserIcon,
      ShieldIcon
    }
    from 'vue-feather-icons';
    // Models
    import School from "../../store/commons/School";

    export default Vue.extend({
    name: 'RomaHeader',
    components:{
      UserIcon,
      ShieldIcon
    },
    props: {
        navigationMenu: {
          type: Boolean,
          default: true,
        },
    },
    data() {
        return {
            openedMenu: false,
        };
    },
    computed: {
        menu() {
            return [
                { title: this.$vuetify.lang.t('$vuetify.generals.closeSession'), route: {}, clickAction: (title: string) => { window.location.href = `${this.$store.state.baseURL}/logout`; } },
            ];
        },
        school: {
            get() {
                const index = this.$store.state.organizer.selectedSchool? this.$store.state.organizer.selectedSchool.id : 0;
                return School.find(index);
            },
            set(school) {
                this.$store.commit('selectSchool', school);
            },
        },
        schools () {
            return School.all();
        }
    },
    methods: {
        toggleUtpView (value: any) {
            this.$store.commit('toggleUtp', value)
        },
    },
});
